// Auto-generated container constants
// This file is generated from values.yaml and environment variables during container startup
// Priority: 1. window.RUNTIME_CONFIG (runtime) -> 2. Build-time defaults
// DO NOT EDIT MANUALLY - changes will be overwritten
import { AcLockObject } from '@utils/ac-lock-object';

// Read configuration from window.RUNTIME_CONFIG (loaded before React bundle)
// Falls back to build-time defaults if runtime config is not available
const getRuntimeOrDefault = (key, defaultValue) => {
  if (typeof window !== 'undefined' && window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key] !== undefined) {
    return window.RUNTIME_CONFIG[key];
  }
  return defaultValue;
};

// Container configuration - reads from window.RUNTIME_CONFIG at runtime
export const CONTAINER_CONFIG = AcLockObject({
  SITE_TITLE: getRuntimeOrDefault('SITE_TITLE', 'Test softwarecatalogus'),
  SITE_DESCRIPTION: getRuntimeOrDefault('SITE_DESCRIPTION', 'Local development instance of the softwarecatalogus'),
  SITE: getRuntimeOrDefault('SITE', 'localhost'),
  MODE: getRuntimeOrDefault('MODE', 'development'),
  THEME_VARIANT: getRuntimeOrDefault('THEME_VARIANT', 'development'),
  FAVICON_URL: getRuntimeOrDefault('FAVICON_URL', '/favicon.svg'),
  ENVIRONMENT_NAME: getRuntimeOrDefault('ENVIRONMENT_NAME', 'development'),
  BASE_URL: getRuntimeOrDefault('BASE_URL', '/api/apps'),
  GRANT_TYPE: getRuntimeOrDefault('GRANT_TYPE', 'authorization_code'),
  CLIENT_ID: getRuntimeOrDefault('CLIENT_ID', ''),
  CLIENT_SECRET: getRuntimeOrDefault('CLIENT_SECRET', ''),
  PROVIDER: getRuntimeOrDefault('PROVIDER', 'nextcloud'),
  REGISTER_URL: getRuntimeOrDefault('REGISTER_URL', ''),
  AUTO_LOGOUT: getRuntimeOrDefault('AUTO_LOGOUT', false),
  AUTO_LOGOUT_TIME: getRuntimeOrDefault('AUTO_LOGOUT_TIME', 3600),
  SESSION_TIMEOUT: getRuntimeOrDefault('SESSION_TIMEOUT', 3600),
  ACTIVITY_PING: getRuntimeOrDefault('ACTIVITY_PING', false),
  ROLLBAR_KEY: getRuntimeOrDefault('ROLLBAR_KEY', ''),
  ROLLBAR_ENVIRONMENT: getRuntimeOrDefault('ROLLBAR_ENVIRONMENT', 'development'),
  ENABLE_AUTHENTICATION: getRuntimeOrDefault('ENABLE_AUTHENTICATION', false),
  ENABLE_GEMMA: getRuntimeOrDefault('ENABLE_GEMMA', true),
  ENABLE_DIRECTORY: getRuntimeOrDefault('ENABLE_DIRECTORY', true),
  ENABLE_ROLLBAR: getRuntimeOrDefault('ENABLE_ROLLBAR', false),
  ENABLE_MOCK_THEMES: getRuntimeOrDefault('ENABLE_MOCK_THEMES', false),
  ENABLE_BREADCRUMBS: getRuntimeOrDefault('ENABLE_BREADCRUMBS', false),
  EXTERNAL_WEBSITE_URL: getRuntimeOrDefault('EXTERNAL_WEBSITE_URL', 'https://www.tilburg.nl/'),
  EXTERNAL_PRIVACY_URL: getRuntimeOrDefault('EXTERNAL_PRIVACY_URL', 'https://www.tilburg.nl/privacystatement/'),
  EXTERNAL_COOKIES_URL: getRuntimeOrDefault('EXTERNAL_COOKIES_URL', 'https://www.tilburg.nl/cookies/'),
  EXTERNAL_PROCLAIMER_URL: getRuntimeOrDefault('EXTERNAL_PROCLAIMER_URL', 'https://www.tilburg.nl/proclaimer/'),
  HERO_IMAGE_URL: getRuntimeOrDefault('HERO_IMAGE_URL', null),
  FOOTER_STYLE: getRuntimeOrDefault('FOOTER_STYLE', 'vng'),
  FOOTER_LOGO_TITLE: getRuntimeOrDefault('FOOTER_LOGO_TITLE', 'Open Tilburg'),
  FOOTER_LOGO_SUBTITLE: getRuntimeOrDefault('FOOTER_LOGO_SUBTITLE', 'Één plek voor alle publicaties van Gemeente Tilburg'),
  SUPPORT_EMAIL_ADDRESS: getRuntimeOrDefault('SUPPORT_EMAIL_ADDRESS', 'info@conduction.nl'),
  DEFAULT_SEARCH_SCHEMA: getRuntimeOrDefault('DEFAULT_SEARCH_SCHEMA', ''),
  CHAT_ENDPOINT: getRuntimeOrDefault('CHAT_ENDPOINT', 'https://api.example.com/chat'),
  CHAT_TITLE: getRuntimeOrDefault('CHAT_TITLE', 'Chat met Open Registers'),
  CHAT_DESCRIPTION: getRuntimeOrDefault('CHAT_DESCRIPTION', 'Stel vragen over data en bestanden in open registers en krijg direct antwoord.'),
  NODE_ENV: getRuntimeOrDefault('NODE_ENV', 'development'),
  BASE_URL_COMMONGROUND: getRuntimeOrDefault('BASE_URL_COMMONGROUND', '/api/apps'),
  NGINX_ROOT_DIR: getRuntimeOrDefault('NGINX_ROOT_DIR', '/usr/share/nginx/html'),
  NGINX_OPENCONNECTOR_UPSTREAM: getRuntimeOrDefault('NGINX_OPENCONNECTOR_UPSTREAM', ''),
  NGINX_NEXTCLOUD_UPSTREAM: getRuntimeOrDefault('NGINX_NEXTCLOUD_UPSTREAM', ''),
  NGINX_NEXTCLOUD_DOMAIN: getRuntimeOrDefault('NGINX_NEXTCLOUD_DOMAIN', ''),
  NGINX_TARGET_HOST: getRuntimeOrDefault('NGINX_TARGET_HOST', ''),
  FAST_REFRESH: getRuntimeOrDefault('FAST_REFRESH', 'true'),
});

// Helper functions to replace hostname-based logic
export const getTitle = () => CONTAINER_CONFIG.SITE_TITLE;
export const getSiteDescription = () => CONTAINER_CONFIG.SITE_DESCRIPTION;
export const getSite = () => CONTAINER_CONFIG.SITE;
export const getMode = () => CONTAINER_CONFIG.MODE;
export const getThemeVariant = () => CONTAINER_CONFIG.THEME_VARIANT;
export const getEnvironmentName = () => CONTAINER_CONFIG.ENVIRONMENT_NAME;
// All API URLs are now unified under BASE_URL
export const getApiUrl = () => CONTAINER_CONFIG.BASE_URL || '/api/apps';
export const getCommongroundApiUrl = () => CONTAINER_CONFIG.BASE_URL || '/api/apps';
export const getGemmaEndpoint = () => CONTAINER_CONFIG.BASE_URL || '/api/apps';
export const getOpenconnectorApiUrl = () => '/api/openconnector';
// Legacy aliases for backward compatibility
export const getApiConfig = getApiUrl;
export const getAuthConfig = () => ({
  grantType: CONTAINER_CONFIG.GRANT_TYPE,
  clientId: CONTAINER_CONFIG.CLIENT_ID,
  clientSecret: CONTAINER_CONFIG.CLIENT_SECRET,
  provider: CONTAINER_CONFIG.PROVIDER,
  registerUrl: CONTAINER_CONFIG.REGISTER_URL,
});
export const getSessionConfig = () => ({
  autoLogout: CONTAINER_CONFIG.AUTO_LOGOUT,
  sessionTimeout: CONTAINER_CONFIG.SESSION_TIMEOUT,
  activityPing: CONTAINER_CONFIG.ACTIVITY_PING,
});
export const getFeatureFlags = () => ({
  enableBreadcrumbs: CONTAINER_CONFIG.ENABLE_BREADCRUMBS,
  enableDirectory: CONTAINER_CONFIG.ENABLE_DIRECTORY,
  enableRollbar: CONTAINER_CONFIG.ENABLE_ROLLBAR,
  enableMockThemes: CONTAINER_CONFIG.ENABLE_MOCK_THEMES,
});
export const getExternalUrls = () => ({
  website: CONTAINER_CONFIG.EXTERNAL_WEBSITE_URL,
  privacy: CONTAINER_CONFIG.EXTERNAL_PRIVACY_URL,
  cookies: CONTAINER_CONFIG.EXTERNAL_COOKIES_URL,
  proclaimer: CONTAINER_CONFIG.EXTERNAL_PROCLAIMER_URL,
});
export const getVisualConfig = () => ({
  heroImageUrl: CONTAINER_CONFIG.HERO_IMAGE_URL,
  faviconUrl: CONTAINER_CONFIG.FAVICON_URL,
  menuPosition: CONTAINER_CONFIG.MENU_POSITION,
  footerStyle: CONTAINER_CONFIG.FOOTER_STYLE,
});

// Image helper functions
export const getHeroImageUrl = () => CONTAINER_CONFIG.HERO_IMAGE_URL;
export const getFaviconUrl = () => CONTAINER_CONFIG.FAVICON_URL;

// Footer text helper functions
export const getFooterLogoTitle = () => CONTAINER_CONFIG.FOOTER_LOGO_TITLE;
export const getFooterLogoSubtitle = () => CONTAINER_CONFIG.FOOTER_LOGO_SUBTITLE;
export const getSupportEmailAddress = () => CONTAINER_CONFIG.SUPPORT_EMAIL_ADDRESS;
// Search helper functions
export const getDefaultSearchSchema = () => CONTAINER_CONFIG.DEFAULT_SEARCH_SCHEMA;
// Chat helper functions
export const getChatEndpoint = () => CONTAINER_CONFIG.CHAT_ENDPOINT;
export const getChatTitle = () => CONTAINER_CONFIG.CHAT_TITLE;
export const getChatDescription = () => CONTAINER_CONFIG.CHAT_DESCRIPTION;
export const isChatEnabled = () => {
  return CONTAINER_CONFIG.CHAT_ENDPOINT && CONTAINER_CONFIG.CHAT_ENDPOINT.trim() !== '';
};
export const getDefaultConfig = () => CONTAINER_CONFIG;
